import { Form, Divider } from 'antd';

import CheckboxMultiSelect from '@/components/CheckboxMultiSelect';
import HeaderWithHelp from '@/components/HeaderWithHelp';
import usePackageInclusionsExclusions from '@/hooks/usePackageInclusionsExclusions';
import PackageService from '@/services/TourServices/PackageService';

import CreateSection from '@/components/CreateInclExclSection';

const Inclusions = ({ initialInclusions }) => {
    const { data, mutate } = usePackageInclusionsExclusions();
    const question = 'What is this?';
    const answer = 'Lorem ipsum dolor sit amet...';
    return (
        <div className="inclusions">
            <HeaderWithHelp
                title="Inclusions"
                question={question}
                answer={answer}
            />

            <Divider />

            <Form.Item name="inclusions">
                <CheckboxMultiSelect
                    options={data?.data.inclusions}
                    labelParamName="name"
                    valueParamName="id"
                    initialCheckedList={initialInclusions}
                />
            </Form.Item>

            <CreateSection
                data={data}
                mutate={mutate}
                buttonText="Add New Inclusion Item"
                addNewItem={PackageService.addNewInclusion}
                tourcategory={2}
            />
        </div>
    );
};

export default Inclusions;
